import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  cssVariables: true,
  typography: {
    fontFamily: "Chubb Publico Text Web, Georgia, Times New Roman, Times, serif"
  },
  palette: {
    primary: {
      main: "#4bcce5",
      contrastText: "#fff"
    },
    error: {
      main: "#d70000"
    },
    text: {
      primary: "#000000"
    }
  },
  custom: {
    magenta: "#fc0386",
    purple: "#6526d9",
    navy: "#000ecc",
    orange: "#FF6600",
    orangeOpacity: "rgba(255, 102, 0, 0.95)",
    grey: "#afafaf",
    darkGrey: "#4B4E53",
    yellow: "#FFB800",
  },
  components: {
    MuiTypography: {
      defaultProps: {
        color: "text.primary"
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#000000"
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            '&:hover': { backgroundColor: theme.palette.primary.dark },
            '& .MuiListItemIcon-root, & .MuiSvgIcon-root': { color: 'inherit' },
            '& .MuiListItemText-primary': { color: 'inherit' },
          },
        }),
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: ({ theme }) => ({
          '&[aria-selected="true"]': {
            backgroundColor: `${theme.palette.primary.main} !important`,
            color: `${theme.palette.primary.contrastText} !important`,
          },
        }),
      },
    },
  },
  
});

export default theme;